import { Flex, Typography } from "antd";
import { ApproveWalletCheckButton, PlateItemFooter } from "components";
import { BidWalletCheckGridDto, RISK_STATUS_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";

export const WalletFooter = observer(
  ({ item, onWalletChecksUpdated }: { item: BidWalletCheckGridDto; onWalletChecksUpdated: () => void }) => {
    const { bidWalletChecks, user } = useStores();

    const riskStatus = item.riskStatus === RISK_STATUS_ENUM.APPROVE_NEEDED;
    const checkId = item.checkId;
    const isRiskManager = user.roles.isRiskManager;

    const showWalletFooter = riskStatus && checkId && isRiskManager;

    if (!showWalletFooter) {
      return null;
    }

    return (
      <PlateItemFooter description="Требуется согласование. Этот кошелёк несёт высокий риск.">
        <ApproveWalletCheckButton
          checkId={item.checkId ?? ""}
          onSuccess={() => {
            bidWalletChecks.fetch();
            onWalletChecksUpdated();
          }}
        />
      </PlateItemFooter>
    );
  }
);
